export const GetStageUtil = (startDate: string, endDate: string) => {
  const TodayDate = new Date();
  if (new Date(startDate) > TodayDate) {
    return { name: 'Pre Travel', stage: 0 };
  } else if (new Date(startDate) <= TodayDate && new Date(endDate) > TodayDate) {
    return { name: 'During Travel', stage: 1 };
  } else return { name: 'Post Travel', stage: 2 };
};
